<template>
  <v-dialog max-width="480" v-model="dialog" persistent>
    <v-card class="text-center">
      <v-card-title class="justify-center">
        <v-icon color="green" size="128">check_circle</v-icon>
      </v-card-title>
      <v-card-title class="headline justify-center">
        <div v-if="successTitle">{{ successTitle }}</div>
        <div v-else>{{ $translate('ORDER_COMPLETED') }}</div>
      </v-card-title>

      <v-card-text class="mt-4" style="word-break: normal">
        <div v-if="successText">{{ successText }}</div>
        <div v-else>{{ $translate('ORDER_COMPLETED_DEFAULT') }}</div>
      </v-card-text>

      <v-col cols="12" align-self="center" justify="center" align="center">
        <v-card flat class="pb-5 buttons">
          <v-btn
            v-if="$store.getters['auth/userName'] != ''"
            color="primary"
            class="primary-font-color"
            depressed
            block
            large
            @click="onContinueClick()"
          >
            <div v-if="continueButtonText">{{ continueButtonText }}</div>
            <div v-else>{{ $translate('VIEW_ORDER') }}</div>
          </v-btn>

          <v-btn
            color="primary"
            depressed
            block
            large
            class="mt-3 primary-font-color"
            @click="onBackClick()"
          >
            <div v-if="backButtonText">{{ backButtonText }}</div>
            <div v-else>{{ $translate('BACK_HOME_PAGE') }}</div>
          </v-btn>
        </v-card>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SuccessDialog',
  props: {
    dialog: Boolean,
    successTitle: String,
    successText: String,
    continueButtonText: String,
    backButtonText: String,
  },
  methods: {
    onContinueClick() {
      this.$emit('continue');
    },
    onBackClick() {
      this.$emit('back');
    },
  },
};
</script>
